/* Stylesheets */
import './scss/vendors/bootstrap.scss'; // ref: https://getbootstrap.com/docs/5.3/customize/sass/#importing
import './scss/vendors/swiper.scss'; // ref: https://swiperjs.com/get-started#installation
import './scss/vendors/hamburgers.scss'; // ref: https://jonsuh.com/hamburgers/#sass
import './scss/fonts.scss';
import './scss/vendors/energy-saver.scss';
import './scss/style.scss';

/* Scripts */
import { Modal } from 'bootstrap'; // ref: https://getbootstrap.com/docs/5.3/getting-started/webpack/#import-bootstrap - Point 3.

import Swiper from 'swiper'; // ref: https://swiperjs.com/get-started#install-from-npm
import { A11y, Autoplay } from 'swiper/modules';

import { library, dom } from '@fortawesome/fontawesome-svg-core'; // ref: https://fontawesome.com/docs/apis/javascript/import-icons#package-names
// import { fab } from '@fortawesome/free-brands-svg-icons';
// import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons';
import { faArrowUpFromBracket, faArrowRightToBracket, faArrowLeftFromBracket, faCircleUser, faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
// import { fat } from '@fortawesome/pro-thin-svg-icons';
// import { fad } from '@fortawesome/pro-duotone-svg-icons';
// import { fass } from '@fortawesome/sharp-solid-svg-icons';
// import { fasr } from '@fortawesome/sharp-regular-svg-icons';
// import { fasl } from '@fortawesome/sharp-light-svg-icons';
// import { fast } from '@fortawesome/sharp-thin-svg-icons';
// library.add(fab, fas, far, fal, fat, fad, fass, fasr, fasl, fast);
library.add(faEye, faEyeSlash, faArrowUpFromBracket, faArrowRightToBracket, faArrowLeftFromBracket, faCircleUser, faCircleInfo);
 dom.i2svg();

import Cleave from 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.it'
import EnergySaver from './js/vendors/energy-saver';

/* Init Functions on DOMContentLoaded */
const ready = (callback) => {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};

const isDebug = process.env.NODE_ENV !== 'production';
const anchorClass = 'anchor';
const activeClass = 'is-active';
let scrollbarWidth = 0;
const mediaMobile = window.matchMedia('(max-width: 991.98px)');

/* Variables and functions */
const initWebpackVersion = () => {
    isDebug && console.log(`%c${DESCRIPTION}`, `color: #9ac456; font-size: 18px; font-weight: 700;`, `Version ${VERSION} - Development Environment`);
};

const el = (domstring) => {
    const html = new DOMParser().parseFromString(domstring, 'text/html')
    return html.body.firstChild
}

const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

const goToAnchor = (el, offset = 0, behavior = 'smooth') => {
    if (typeof el === 'string') {
        el = document.querySelector(el);
    }

    if (el) {
        let anchorOffset = 0;
        const anchor = document.querySelector('.' + anchorClass)
        if (anchor && !el.classList.contains(anchorClass)) {
            const style = getComputedStyle(anchor)
            if (isNumeric(parseInt(style.top, 10))) {
                anchorOffset = parseInt(style.top, 10);
            }
        }

        const y = el.getBoundingClientRect().top + window.pageYOffset + anchorOffset - offset
        window.scrollTo({
            top: y,
            behavior: behavior
        })
    }
}

const convertRemToPixels = (rem) => {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

const ValidatorUpdateDisplay = (val) => {
    if (typeof (val.display) == "string") {
        if (val.display == "None") {
            return;
        }
        if (val.display == "Dynamic") {
            val.style.display = val.isvalid ? "none" : "block";
            ValidatorInput(val);
            return;
        }
    }
    if ((navigator.userAgent.indexOf("Mac") > -1) &&
        (navigator.userAgent.indexOf("MSIE") > -1)) {
        val.style.display = "inline";
    }
    val.style.visibility = val.isvalid ? "hidden" : "visible";
    ValidatorInput(val);
}

const ValidatorInput = (val) => {
    const elements = Array.from(val.parentNode.querySelectorAll('input, select'));
    const invalidClass = 'is-invalid';

    if (val.isvalid) {
        val.classList.remove(invalidClass);
    } else {
        val.classList.add(invalidClass);
    }

    const feedbacks = Array.from(val.parentNode?.querySelectorAll('.invalid-feedback'));
    const isInputInvalid = feedbacks.find(item => item.classList.contains(invalidClass));
    elements.forEach(elem => {
        isInputInvalid ? elem.classList.add(invalidClass) : elem.classList.remove(invalidClass);
        isInputInvalid ? elem.setAttribute('aria-invalid', true) : elem.removeAttribute('aria-invalid');
    });
}

const IsValidationGroupMatch = (control, validationGroup) => {
    if ((typeof (validationGroup) == "undefined") || (validationGroup == null)) {
        return true;
    }
    let controlGroup = "";
    if (typeof (control.validationGroup) == "string") {
        controlGroup = control.validationGroup;
    }
    return (controlGroup == validationGroup);
};

const ValidationSummaryOnSubmit = (validationGroup, message = null, target = null, success = false) => {
    const alertOffset = 2 //rem

    if (typeof (Page_ValidationSummaries) == "undefined")
        return;
    let summary, sums, s;
    for (sums = 0; sums < Page_ValidationSummaries.length; sums++) {
        summary = Page_ValidationSummaries[sums];
        if (!summary) continue;
        summary.style.display = "none";
        if (message && IsValidationGroupMatch(summary, validationGroup)) {
            if (summary.showsummary !== "False") {
                summary.style.display = "";
                s = message;
                summary.innerHTML = s;
                if (success) {
                    summary.classList.remove('alert-danger')
                    summary.classList.add('alert-success')
                } else {
                    summary.classList.add('alert-danger');
                    summary.classList.remove('alert-success');
                }
                if (target) {
                    goToAnchor(target, convertRemToPixels(alertOffset));
                } else {
                    goToAnchor(summary, convertRemToPixels(alertOffset));
                }
            }
        } else if (!Page_IsValid && IsValidationGroupMatch(summary, validationGroup)) {
            if (summary.showsummary !== "False" && summary.headertext) {
                summary.style.display = "";
                s = summary.headertext;
                summary.innerHTML = s;
                summary.classList.add('alert-danger');
                summary.classList.remove('alert-success');
                if (target) {
                    goToAnchor(target, convertRemToPixels(alertOffset));
                } else {
                    goToAnchor(summary, convertRemToPixels(alertOffset));
                }
            }
        }
    }
}

const popMessage = (validationGroup, message = "", target = null, success = false) => {
    ValidationSummaryOnSubmit(validationGroup, message, target, success);
}

const showLoading = (el) => {
    if (!el)
        return;
    console.log(el);
    el?.classList.add('disabled');

    const loadingLayer = document.querySelector('.loading_layer');
    if (loadingLayer) {
        loadingLayer.style.display = 'block';
    }
};


const showSpinner = () => { 
    const loadingLayer = document.querySelector('.loading_spinner');
    if (loadingLayer) {
        loadingLayer.style.display = 'block';
    }
};


const hideLoading = () => {
    const loadingButtons = [...document.querySelectorAll('.btn-loading')]
    loadingButtons.forEach(button => {
        button.classList.remove('disabled')
    })

    const loadingLayer = document.querySelector('.loading_layer')
    if (loadingLayer) {
        loadingLayer.style.display = 'none'
    }
};


const hideSpinner = () => {
    const loadingLayer = document.querySelector('.loading_spinner')
    if (loadingLayer) {
        loadingLayer.style.display = 'none'
    }
};


//Mostra pssw al click su icona-occhio
const showPassword = () => {
    const eyeBtns = [...document.querySelectorAll('.eye-wrap')]
    if (eyeBtns) {
        eyeBtns.forEach((element) => element.addEventListener('click', (evt) => {

            let formFloating = element.previousElementSibling;
            let pswBox = formFloating.querySelector('.form-control');

            if (element.classList.contains('hide')) {
                element.classList.remove('hide');
                element.classList.add('show');
                element.querySelector('.fa-eye').classList.add('d-none');
                element.querySelector('.fa-eye-slash').classList.remove('d-none');
                pswBox.type = "text";
            }
            else {
                element.classList.add('hide');
                element.classList.remove('show');
                element.querySelector('.fa-eye-slash').classList.add('d-none');
                element.querySelector('.fa-eye').classList.remove('d-none');
                pswBox.type = "password";
            }
        }));
    }
}


const initMenu = () => {
    window.addEventListener('scroll', fixHeader);
    const menuLinks = [...document.querySelectorAll('.nav-link')]
    menuLinks.forEach(link => {
        link.addEventListener('click', ev => {
            ev.preventDefault()
            if (mediaMobile.matches) {
                hamburgerMenu.click()
                // setTimeout(function () {
                location.href = ev.target.href
                // }, 400)
            } else {
                location.href = ev.target.href
            }
        })
    })
};

const initCleave = () => {
    // data
    const datascontrino = document.getElementById('txtDataScontrino');
    if (datascontrino) {         
        new Cleave(datascontrino, {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y']
        });
    }
    const dataDoc = document.getElementById('txtDataDoc');
    if (dataDoc) {         
        new Cleave(dataDoc, {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y']
        });
    }
    // orario
    const orarioscontrino = document.getElementById('txtOraScontrino');
    if (orarioscontrino) {
        new Cleave(orarioscontrino, {
            time: true,
            delimiter: ':',
            timePattern: ['h', 'm']
        });
    }
    // numero
    const numeroScontrino = document.getElementById('txtNumeroScontrino');
    if (numeroScontrino) {
       new Cleave(numeroScontrino, {
            blocks: [4, 4],
            delimiter: '-',
            numericOnly: true
       });
    }

    // importo todo: fixare
    const importoscontrino = document.getElementById('txtImportoScontrino');
    if (importoscontrino) {
        new Cleave(importoscontrino, {
            blocks: [6],
            numeral: true,
            delimiter: '',
            numeralDecimalScale: 2,
            numeralDecimalMark: ',',
        });
    }

    // UTENTE ****************

    // DATA NASCITA
    const txtDataNascita = document.querySelector('#txtDataNascita')
    if (txtDataNascita) {
        new Cleave(txtDataNascita, {
            date: true,
            delimiter: '/',
            datePattern: ['d', 'm', 'Y']
        })
    }
    // CAP
    const txtCAP = document.querySelector('#txtCAP')
    if (txtCAP) {
        new Cleave(txtCAP, {
            blocks: [5],
            numericOnly: true
        })
    }
};

//EnergySaver
const energyS = new EnergySaver({
    //idle: 2000,
    enableZeroImpact: false,
    enableCredits:true
});

const initSwiper = () => {
    console.log('initSwiper');
    const swiper = new Swiper(".sliderPremi", {
        modules: [A11y, Autoplay],
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true
    });
};

//Expose functions
window.ValidatorUpdateDisplay = ValidatorUpdateDisplay;
window.ValidationSummaryOnSubmit = ValidationSummaryOnSubmit;
window.showLoading = showLoading;
window.hideLoading = hideLoading;
window.showSpinner = showSpinner;
window.hideSpinner = hideSpinner;
window.popMessage = popMessage;
window.goToAnchor = goToAnchor;


/* Ready callback function */
ready(() => {
    initWebpackVersion();
    //initSwiper();
    initCleave();
    showPassword();
    
    // Inizializza le modali Bootstrap
    const modalElements = document.querySelectorAll('.modal');
    modalElements.forEach(modalElement => {
        new Modal(modalElement);
    });
});
